import React from 'react'
import { imageUrl } from '@libs/appUrl'
import { useTranslation } from '@i18n'
import { styles } from './BottomBar.styles'

function BottomBar(props) {
  const { url } = props
  const { like, reply, saved } = props.post
  const { t } = useTranslation('post')

  return (
    <div>
      <div className="bar-container">
        <div className="bar-container__buttonList">
          <a href={url} className="bar-container__buttonList__button">
            <amp-img alt="like" src={imageUrl('img/icon/heart@3x.png')} width="18" height="18" />
            <span className="bar-container__buttonList__button-margin">{t('bottomBar.like')}</span>
            <span>{like}</span>
          </a>
          <a href={url} className="bar-container__buttonList__button left_and_right_border">
            <amp-img
              alt="reply"
              src={imageUrl('img/icon/inactive_3@3x.png')}
              width="18"
              height="18"
            />
            <span className="bar-container__buttonList__button-margin">{t('bottomBar.reply')}</span>
            <span>{reply}</span>
          </a>
          <a href={url} className="bar-container__buttonList__button">
            <amp-img
              alt="saved"
              src={imageUrl('img/icon/inactive_2@3x.png')}
              width="18"
              height="18"
            />
            <span className="bar-container__buttonList__button-margin">{t('bottomBar.saved')}</span>
            <span>{saved}</span>
          </a>
        </div>
      </div>
      <style jsx>{styles}</style>
    </div>
  )
}

export default BottomBar
